export default __webpack_public_path__ + "./images/vi.c72d4676.png";